import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-striped-rows-table',
	templateUrl: './striped-rows-table.component.html',
	styleUrls: ['./striped-rows-table.component.css']
})
export class StripedRowsTableComponent implements OnInit, OnChanges {
	@Input() tabledHeaderBody: { header: any[], keys: any[], data: any[], pagination: any };
	@Output() actionEvent = new EventEmitter<any>();
	constructor() { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes.tabledHeaderBody.currentValue) {
			// console.log(changes.tabledHeaderBody.currentValue);
		}
	}

	ngOnInit() {
	}

	findDataType(property: string) {
		return typeof property;
	}

	onActionClick(name: string, index: number) {
		this.actionEvent.emit({ name: name, data: this.tabledHeaderBody.data[index] });
	}

}
